<template>
  <div class="mt-3 mb-3 row row-cols-lg-12 principal-stepper">
    <ul class="progressbar">
      <li
        :class="pasoActual <= index ? 'active' : ''"
        v-for="(paso, index) in pasos"
        :key="index"
      >
      <label>
        {{ paso }}
      </label>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    pasos: Array,
    pasoActual: Number
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">

$color-primario: #b8725a;

$poppins: "Poppins";

$gris-deshabilitado: #bcbcbc;

 

.progressbar {

  counter-reset: step;

}

.progressbar li {

  list-style-type: none;

  width: 20%;

  font-size: 16px;

  position: relative;

  text-align: center;

  text-transform: capitalize;

  font-family: $poppins;

  font-weight: 700;

  color: $color-primario;

  float: left;

}

 

.progressbar li:before {

  content: "";

  counter-increment: step;

  width: 15px;

  height: 15px;

  border: 4px solid $color-primario;

  display: block;

  margin: 0 auto 10px auto;

  border-radius: 50%;

  line-height: 27px;

  background: white;

  color: #bebebe;

  text-align: center;

  font-weight: bold;

  z-index: 1;

}

.progressbar li:after {

  content: "";

  position: absolute;

  width: 100%;

  height: 3px;

  background: $color-primario;

  top: 7px;

  left: -50%;

  z-index: -1;

}

.progressbar li.active:before {

  border-color: $gris-deshabilitado;

  background: white;

  color: white;

}

.progressbar li.active:after {

  background: $gris-deshabilitado;

}

.progressbar li.active ~ li:after {

  background: $gris-deshabilitado;

}

.progressbar li.active ~ li:before {

  border-color: $gris-deshabilitado;

  background: white;

  color: white;

  z-index: 1;

}

.progressbar li:first-child:after {

  content: none;

  z-index: 1;

}

.progressbar li.active label {

  color: $gris-deshabilitado;

  z-index: 1;

}

 

@media all and (max-width: 767px) {

  .principal-stepper {

    display: none;

  }
}

</style>
